<template lang="html">
  <layout>
    <v-container grid-list-xl>
      <v-layout column>
        <v-flex>
          <h1>Resources</h1>
        </v-flex>
        <v-flex>
          <v-card class="blue-grey lighten-4">
            <v-container grid-list-xl>
              <v-layout row  wrap justify-center align-center fill-height>
                <v-flex xs12 sm2 md2>
                  <v-img src="static/images/150_workbench_ipad.png" self-align-center />
                </v-flex>
                <v-flex xs12 sm10 md8>
                  <h2>Allura In-Home Presentation</h2>
                  <p>
                    A guided walkthrough presentation to help communicate the Allura story and products to your customers. Presented as a website, add it to your tablet’s home screen for offline usage.
                  </p>
                  <v-layout row justify-space-around>
                    <v-flex xs12 sm2>
                      <v-btn color="secondary" href="static/sales_helpers/tm_launch_ppt.pptx.pdf" target="_blank">Next Steps</v-btn>
                    </v-flex>
                    <v-flex xs12 sm3>
                      <v-btn color="secondary" href="static/sales_helpers/allura_in_home_presentation_notes.pdf" target="_blank">Presenter Notes</v-btn>
                    </v-flex>
                    <v-flex xs12 sm3>
                      <v-btn color="secondary" href="static/sales_helpers/allura_comparison_sheet.pdf" target="_blank">Comparison Sheet</v-btn>
                    </v-flex>
                    <v-flex xs12 sm3>
                      <v-btn color="secondary" href="static/financing/a1710_rpw_allco_222_warranty_8.5x11_mech_(0519).pdf" target="_blank">Warranty</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md2 d-flex justify-center align-center>
                  <v-btn color="primary" href="https://preso.allurausa.com/" target="_blank" block class="no-text-transform">
                    <span style="white-space: normal; text-align: center;">View and Download Presentation</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex>
          <v-card class="blue-grey lighten-4">
            <v-container grid-list-xl>
              <v-layout row wrap justify-center align-center fill-height>
                <v-flex xs12 sm8 md8>
                  <h2>ALLURA INSTALLATION TRAINING</h2>
                  <p>
                    We expect our remodelers to install Allura siding to the correct specification. Prior to receiving a rebate, the test must be taken and submitted. Installation experts also available to advise in order to ensure a quality installation. Your local representative will reach out to make sure you’re well on your way to becoming an Allura expert.
                  </p>
                </v-flex>
                <v-spacer />
                <v-flex xs12 sm4 md2 d-flex justify-center align-center>
                  <v-btn color="primary" @click="training = true">Show More</v-btn>
                </v-flex>
                <v-dialog
                  v-model="training"
                  max-width="600px"
                  transition="dialog-transition">
                  <v-card>
                    <v-card-text>
                      <v-data-table
                        :headers="headers"
                        :items="trainingItems"
                        hide-actions
                        class="elevation-1">
                        <template v-slot:items="props">
                          <td>{{ props.item.description }}</td>
                          <td>{{ props.item.type }}</td>
                          <td><v-btn color="primary" :href="props.item.link" target="_blank" :download="props.item.download">view</v-btn></td>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex>
          <v-card class="blue-grey lighten-4">
            <v-container grid-list-xl>
              <v-layout row wrap justify-center align-center fill-height>
                <v-flex xs12>
                  <h2>Tool Suggestions</h2>
                </v-flex>
                <v-flex xs12 sm12 md12 d-flex justify-center align-center>
                  <v-btn color="secondary" self-align-center href="static/tools/TM_Tool_Suggestions.pdf" target="_blank">Fiber Cement Tools</v-btn>
                  <v-btn color="secondary" self-align-center href="static/tools/Ezi-gauge_selling_sheet.pdf" target="_blank">EZI Guage Selling Sheet</v-btn>
                </v-flex>
                <v-dialog
                  v-model="training"
                  max-width="600px"
                  transition="dialog-transition">
                  <v-card>
                    <v-card-text>
                      <v-data-table
                        :headers="headers"
                        :items="trainingItems"
                        hide-actions
                        class="elevation-1">
                        <template v-slot:items="props">
                          <td>{{ props.item.description }}</td>
                          <td>{{ props.item.type }}</td>
                          <td><v-btn color="primary" :href="props.item.link" target="_blank" :download="props.item.download">view</v-btn></td>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex v-if="this.$auth.role === 'Remodeler'">
          <v-card class="blue-grey lighten-4">
            <v-container grid-list-xl>
              <v-layout row wrap justify-center align-center fill-height>
                <v-flex xs12 md6 >
                  <h2>SAMPLES & COLLATERAL</h2>
                  <h3>Kit Contents</h3>
                  <v-layout row wrap justify-center>
                    <v-flex xs6>
                      <ul>
                        <li>10 warranties</li>
                        <li>10 comparison sheets</li>
                        <li>5 product catalogues</li>
                      </ul>
                    </v-flex>
                    <v-flex xs6>
                      <ul>
                        <li>1 install manual</li>
                        <li>More coming</li>
                      </ul>
                    </v-flex>
                    <v-flex xs12 justify-space-around>
                      <v-btn color="secondary" align-self-center @click="getProfile()">Request Remodeler Kit</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-spacer />
                <v-flex xs12 md6 d-flex justify-center align-center>
                  <v-img src="static/images/R49-Taupe.jpg" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex>
          <v-card class="blue-grey lighten-4">
            <v-container grid-list-xl>
              <v-layout row wrap justify-center align-center fill-height>
                <v-flex xs12 md8>
                  <h2>ADDED VALUE</h2>
                  <p>
                    We expect our remodelers to install Allura siding to the correct specification. Prior to receiving a rebate, the test must be taken and submitted. Installation experts also available to advise in order to ensure a quality installation. Your local representative will reach out to make sure you’re well on your way to becoming an Allura expert.
                  </p>
                </v-flex>
                <v-spacer />
                <v-flex xs12 md2 d-flex justify-center align-center>
                  <v-btn color="primary" @click="financing = true">Show More</v-btn>
                </v-flex>
                <v-dialog
                  v-model="financing"
                  max-width="600px"
                  transition="dialog-transition">
                  <v-card>
                    <v-card-text>
                      <v-data-table
                        :headers="headers"
                        :items="financingItems"
                        hide-actions
                        class="elevation-1">
                        <template v-slot:items="props">
                          <td>{{ props.item.description }}</td>
                          <td>{{ props.item.type }}</td>
                          <td><v-btn color="primary" :href="props.item.link" target="_blank">view</v-btn></td>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog
      v-model="dialog"
      max-width="500px"
      transition="dialog-transition"
      v-if="dialog">
      <v-card v-if="!thankYou">
        <v-card-title primary-title>
          <h3>What Sample Kit would you like?</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              Company: {{remodeler.name}} <br/>
              Name: {{remodeler.first_name}} {{remodeler.last_name}} <br/>
              Address: {{remodeler.locations[0].address}} <br />
              {{ remodeler.locations[0].city}}, {{ remodeler.locations[0].state}} {{ remodeler.locations[0].zip}}
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-flex>
            <v-btn color="primary" @click="requestSample('Primed')">Primed</v-btn><br/>
            * contains primed samples
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex text-md-right>
            <v-btn color="primary" @click="requestSample('Pre Finished')">Pre Finished</v-btn><br/>
            * contains pre-finished samples
          </v-flex>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <h2> Thank you! Your request has been sent! </h2>
      </v-card>
    </v-dialog>
  </layout>
</template>

<script>
import Layout from '../shared/Layout'
import axios from 'axios'

export default {
  data () {
    return {
      training: false,
      financing: false,
      dialog: false,
      remodeler: '',
      thankYou: false,
      headers: [
        {
          text: 'Description',
          value: 'description',
          sortable: false
        },
        {
          text: 'Type',
          value: 'type',
          sortable: false
        },
        {
          text: 'Open',
          value: 'link',
          sortable: false
        }
      ],
      trainingItems: [
        {
          description: 'Allura Siding Installation Training Video',
          type: 'Video',
          link: 'https://www.youtube.com/watch?v=qeygNX-Z18w'
        },
        {
          description: 'Siding and Trim Installation Training Module',
          type: 'Document',
          link: 'static/training/lap_and_trim_installation_training_module.pdf'
        },
        {
          description: 'Siding and Trim Installation Test (pdf)',
          type: 'Document',
          link: 'static/training/allura_advanced_training_exam_0119.pdf',
          download: true
        }
      ],
      financingItems: [
        {
          description: 'Financing',
          type: 'Document',
          link: 'static/financing/allura_in_home_finance_flyer_pdf_fillable.pdf'
        },
        {
          description: 'Free Radius Marketing',
          type: 'Link',
          link: 'http://allura.radiusmarketing.com'
        },
        {
          description: 'Allura-Tamlyn Weather Barrier Wrap Flyer',
          type: 'Document',
          link: 'static/misc/allura_tamlyn_wrap.pdf'
        },
        {
          description: 'Allura-Tamlyn Trim Flyer',
          type: 'Document',
          link: 'static/misc/allura_tamlyn_trim.pdf'
        }
      ]
    }
  },
  components: {
    Layout
  },
  methods: {
    getProfile () {
      this.$http({
        method: 'get',
        url: '/remodeler/profile'
      }).then((response) => {
        this.remodeler = response.data
        this.remodeler.hq = response.data.locations[0]
        this.dialog = true
      })
    },
    requestSample (option) {
      this.remodeler.kit = option
      axios({
        method: 'post',
        url: process.env.CRM_API_URL + '/api/v1/email/send',
        headers: {'Authorization': 'Token token=n9438pplrwcxbJuiRml7fefLDl4JuWFUS7hvSKF7pI09L5B2ogDXiL0nc94yf4v'},
        data: {
          template_id: process.env.SAMPLE_TEMPLATE_ID,
          from_email: 'noreply@allurausa.com',
          to_emails: [ 'accounts@bezar.io', 'toanderson@elementia.com' ],
          template_data: this.remodeler
        }
      }).then((response) => {
        console.log(response)
      }).catch((err) => {
        console.log(err)
      })
      this.thankYou = true
    }
  },
  mounted () {
    // this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$auth.accessToken
  }
}
</script>

<style lang="css" scoped>
.no-text-transform{
  height: auto;
  text-align: auto;
  padding: .5em;
}
h2{
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/Resources.vue